/*
 * Elefanten Holz - product configurator enhancements  (DIAGNOSTIC BUILD)
 * ----------------------------------------------------------------------
 * All fixes kept. Extra [cfg] console logging to trace the jump on a
 * variant change. Set CFG_DEBUG = false once diagnosed.
 *
 * JUMP FIX: on product:rerender we strip the variant-picker block from the
 * incoming fragment (capture phase, before the theme's product-rerender.js),
 * so the theme leaves our live picker in place = no replacement, no jump.
 */
(function () {
  'use strict';

  var CFG_DEBUG = true;

  function log() {
    if (!CFG_DEBUG || !window.console) return;
    var a = Array.prototype.slice.call(arguments);
    a.unshift('[cfg]');
    try { console.log.apply(console, a); } catch (e) {}
  }

  var CONFIG = {
    colorOptionNames: ['farbvarianten', 'farbe'],
    labelMap: { 'farbvarianten': 'Farbe' },
    materials: ['Holz', 'Acryl']
  };

  /* ---------- helpers ---------- */

  function accessibleName(el) {
    if (!el) return '';
    var sr = el.querySelector('.sr-only');
    return (el.getAttribute('aria-label') ||
            (sr && sr.textContent) ||
            el.getAttribute('title') ||
            el.textContent || '').trim();
  }

  function materialOf(name) {
    for (var i = 0; i < CONFIG.materials.length; i++) {
      if (name.toLowerCase().indexOf(CONFIG.materials[i].toLowerCase() + ' ') === 0) {
        return CONFIG.materials[i];
      }
    }
    return '';
  }

  function optionPairs(wrap) {
    var pairs = [];
    Array.prototype.slice.call(wrap.children).forEach(function (node) {
      if (node.tagName === 'INPUT') {
        pairs.push({ input: node, label: null });
      } else if (pairs.length && !pairs[pairs.length - 1].label) {
        pairs[pairs.length - 1].label = node;
      } else {
        pairs.push({ input: node.querySelector('input') || null, label: node });
      }
    });
    return pairs;
  }

  function labelFor(wrap, input) {
    if (!input) return null;
    var byId = wrap.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
    return byId || input.nextElementSibling || null;
  }

  function blockLabel(el) {
    if (!el || el.nodeType !== 1) return String(el);
    var t = el.getAttribute && el.getAttribute('data-block-type');
    var id = el.getAttribute && el.getAttribute('data-block-id');
    if (t || id) return (t || '?') + '#' + (id || '?');
    if (el.tagName === 'VARIANT-PICKER') return 'VARIANT-PICKER{tag=' + el.__cfgTag + '}';
    var c = el.className ? '.' + String(el.className).trim().split(/\s+/).slice(0, 2).join('.') : '';
    return el.tagName.toLowerCase() + c;
  }

  /* ---------- material toggle ---------- */

  function buildMaterialToggle(fieldset) {
    var wrap = fieldset.querySelector('.variant-picker__option-values');
    if (!wrap) return;

    var pairs = optionPairs(wrap);
    var present = {};
    pairs.forEach(function (p) {
      var nameEl = p.label || p.input;
      var mat = materialOf(accessibleName(nameEl));
      if (p.input) p.input.setAttribute('data-material', mat);
      if (p.label) p.label.setAttribute('data-material', mat);
      if (mat) present[mat] = true;
    });

    var mats = CONFIG.materials.filter(function (m) { return present[m]; });
    if (mats.length < 2) return;

    var bar = document.createElement('div');
    bar.className = 'cfg-material';
    mats.forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cfg-material__btn';
      b.textContent = m;
      b.setAttribute('data-material', m);
      b.addEventListener('click', function () {
        window.__cfgMaterial = m;
        selectMaterial(fieldset, m, true);
      });
      bar.appendChild(b);
    });
    wrap.parentNode.insertBefore(bar, wrap);

    var checked = wrap.querySelector('input:checked');
    var fromChecked = checked ? checked.getAttribute('data-material') : '';
    var initial = window.__cfgMaterial && mats.indexOf(window.__cfgMaterial) !== -1
      ? window.__cfgMaterial
      : (fromChecked || mats[0]);
    window.__cfgMaterial = initial;
    selectMaterial(fieldset, initial, false);
  }

  function selectMaterial(fieldset, material, doSelect) {
    fieldset.querySelectorAll('.cfg-material__btn').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-material') === material);
    });

    var picker = fieldset.closest('variant-picker');
    if (picker) picker.setAttribute('data-material', material);
    window.__cfgMaterial = material;

    var wrap = fieldset.querySelector('.variant-picker__option-values');

    // apply the robust (inline display) material filter to the whole picker
    resyncMaterial(fieldset.closest('variant-picker') || document);

    if (!doSelect) return;

    // find the first VISIBLE input of the chosen material to select
    var firstInput = null;
    optionPairs(wrap).forEach(function (p) {
      if (firstInput || !p.input) return;
      if (materialOf(accessibleName(p.label || p.input)) === material) firstInput = p.input;
    });
    if (!firstInput) return;

    var checked = wrap.querySelector('input:checked');
    var checkedMat = checked ? materialOf(accessibleName(labelFor(wrap, checked) || checked)) : '';
    if (checkedMat === material) return;  // current colour already in this material

    firstInput.checked = true;
    firstInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------- step numbering + relabel ---------- */

  function numberSteps(picker) {
    var root = picker.closest('.product') || document;
    var steps = root.querySelectorAll('.variant-picker__option, .cfg-personalization');
    var n = 1;
    steps.forEach(function (step) {
      var legend = step.querySelector('legend') ||
                   step.querySelector('.cfg-personalization__title');
      if (!legend) return;

      var valueSpan = legend.querySelector('span, .variant-picker__selected-value, [class*="selected"]');

      var base = legend.getAttribute('data-label');
      if (base === null) {
        var labelText = '';
        Array.prototype.forEach.call(legend.childNodes, function (node) {
          if (node.nodeType === 3) labelText += node.textContent;
        });
        base = labelText.replace(/^\s*\d+\.\s*/, '').trim();
        var key = base.replace(/:$/, '').trim().toLowerCase();
        if (CONFIG.labelMap[key]) base = CONFIG.labelMap[key] + (base.slice(-1) === ':' ? '' : ':');
        legend.setAttribute('data-label', base);
      }

      if (valueSpan) {
        while (legend.firstChild) legend.removeChild(legend.firstChild);
        legend.appendChild(document.createTextNode(n + '. ' + base + ' '));
        legend.appendChild(valueSpan);
      } else {
        legend.textContent = n + '. ' + base;
      }
      n++;
    });
  }

  function updateSelectedValues(scope) {
    (scope || document).querySelectorAll('.variant-picker__option').forEach(function (opt) {
      var legend = opt.querySelector('legend');
      if (!legend) return;
      var wrap = opt.querySelector('.variant-picker__option-values');
      if (!wrap) return;
      var checked = wrap.querySelector('input:checked');
      if (!checked) return;

      // read the selected value robustly: the label's tooltip/title/sr-only/text
      var lbl = labelFor(wrap, checked);
      var name = '';
      if (lbl) {
        name = (lbl.getAttribute('data-tooltip') ||
                lbl.getAttribute('title') ||
                (lbl.querySelector('.sr-only') && lbl.querySelector('.sr-only').textContent) ||
                lbl.textContent || '').trim();
      }
      if (!name) name = (checked.value || '').trim();
      if (!name) return;

      // reuse the value span that sits right after the legend; create one for
      // options that do not have it (step 1)
      var span = null;
      var sib = legend.nextElementSibling;
      if (sib && sib.tagName === 'SPAN' &&
          !sib.classList.contains('sr-only') &&
          !/animated|plus|icon/i.test(sib.className || '')) {
        span = sib;
      }
      if (!span && legend.parentNode) {
        span = legend.parentNode.querySelector('.cfg-selected-value');
      }
      if (!span) {
        span = document.createElement('span');
        span.className = 'cfg-selected-value';
        legend.insertAdjacentElement('afterend', span);
      }

      span.textContent = name;

      // drop any duplicate value spans we may have created
      if (legend.parentNode) {
        legend.parentNode.querySelectorAll('.cfg-selected-value').forEach(function (extra) {
          if (extra !== span) extra.parentNode.removeChild(extra);
        });
      }
    });
  }

  var cfgTagSeq = 0;

  function enhancePicker(picker) {
    if (!picker.hasAttribute('data-cfg')) {
      picker.setAttribute('data-cfg', '1');
      picker.__cfgTag = ++cfgTagSeq;
      log('enhancePicker: tagged NEW picker instance tag=' + picker.__cfgTag +
          ' (if this logs on every variant change, the picker is being REPLACED)');
      picker.querySelectorAll('.variant-picker__option').forEach(function (fs) {
        var wrap = fs.querySelector('.variant-picker__option-values');
        if (!wrap) return;
        var present = {};
        wrap.querySelectorAll('.color-swatch, .block-swatch').forEach(function (l) {
          var mat = materialOf(accessibleName(l));
          if (mat) present[mat] = true;
        });
        var mats = CONFIG.materials.filter(function (m) { return present[m]; });
        if (mats.length >= 2) buildMaterialToggle(fs);

        var legend = fs.querySelector('legend');
        var key = legend ? legend.textContent.replace(/^\s*\d+\.\s*/, '').replace(/:$/, '').trim().toLowerCase() : '';
        if (legend && CONFIG.labelMap[key]) legend.textContent = CONFIG.labelMap[key] + ':';
      });
    }
    numberSteps(picker);
  }

  /* ---------- delivery estimate ---------- */

  function isWeekend(d) { var g = d.getDay(); return g === 0 || g === 6; }

  function addBusinessDays(date, days) {
    var d = new Date(date), added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); if (!isWeekend(d)) added++; }
    return d;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function deliveryRange(min, max) {
    var today = new Date();
    var start = addBusinessDays(today, Math.max(1, min));
    var end = addBusinessDays(today, Math.max(min, max));
    var sd = pad(start.getDate()) + '.' + pad(start.getMonth() + 1) + '.';
    var ed = pad(end.getDate()) + '.' + pad(end.getMonth() + 1) + '.';
    if (start.getFullYear() !== end.getFullYear()) {
      return sd + start.getFullYear() + '\u2013' + ed + end.getFullYear();
    }
    return sd + '\u2013' + ed + end.getFullYear();
  }

  function renderDelivery(scope) {
    (scope || document).querySelectorAll('.cfg-delivery').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-max'), 10) || 4;
      var t = el.querySelector('.cfg-delivery__text');
      if (t) t.textContent = 'Lieferung ' + deliveryRange(min, max);
      el.setAttribute('data-cfg-done', '1');
    });
  }

  /* ---------- sticky-bar quantity sync ---------- */

  function mainQtyInput() {
    return document.querySelector('quantity-selector input[name="quantity"], input[name="quantity"]:not(.cfg-sticky-qty__input)');
  }

  function bindStickyQty() {
    document.querySelectorAll('.cfg-sticky-qty').forEach(function (box) {
      if (box.hasAttribute('data-bound')) return;
      box.setAttribute('data-bound', '1');
      var val = box.querySelector('.cfg-sticky-qty__value');
      box.addEventListener('click', function (e) {
        var btn = e.target.closest('button'); if (!btn) return;
        var main = mainQtyInput(); if (!main) return;
        var q = parseInt(main.value, 10) || 1;
        q += parseInt(btn.getAttribute('data-step'), 10);
        if (q < 1) q = 1;
        main.value = q;
        main.dispatchEvent(new Event('change', { bubbles: true }));
        if (val) val.textContent = q;
      });
    });
  }

  /* ---------- optional personalization: drop empty properties ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.querySelector) return;
    var emptied = [];
    form.querySelectorAll('.cfg-field input').forEach(function (i) {
      if (!i.value.trim() && !i.disabled) { i.disabled = true; emptied.push(i); }
    });
    setTimeout(function () { emptied.forEach(function (i) { i.disabled = false; }); }, 0);
  }, true);

  /* ---------- header layout ---------- */

  function arrangeHeader(scope) {
    scope = scope || document;

    scope.querySelectorAll('.product-info__block-item[data-block-type="text"]').forEach(function (b) {
      if (/mwst/i.test(b.textContent)) b.style.display = 'none';
    });

    scope.querySelectorAll('.product-sticky-bar__info').forEach(function (info) {
      var priceText = '';
      var priceBlock = document.querySelector('.product-info__block-item[data-block-type="price"]');
      if (priceBlock) {
        var el = priceBlock.querySelector('sale-price') ||
                 priceBlock.querySelector('.price-list__sale-price') ||
                 priceBlock.querySelector('.price-list > *:first-child');
        var raw = (el ? el.textContent : '').replace(/\s+/g, ' ');
        raw = raw.replace(/Angebot|Sonderpreis|Normaler Preis|Regul[\u00e4a]rer Preis/gi, '').trim();
        var m = raw.match(/[\u20ac$\u00a3]\s?\d[\d.,]*|\d[\d.,]*\s?[\u20ac$\u00a3]/);
        priceText = m ? m[0].trim() : raw;
      }

      var priceEl = info.querySelector('.cfg-sticky-price');
      if (!priceEl) {
        priceEl = document.createElement('span');
        priceEl.className = 'cfg-sticky-price';
        info.insertBefore(priceEl, info.firstChild);
      }
      if (priceText) priceEl.textContent = priceText;

      if (!info.querySelector('.cfg-sticky-mwst')) {
        var s = document.createElement('span');
        s.className = 'cfg-sticky-mwst';
        s.textContent = 'inkl. MwSt., zzgl. Versand';
        info.appendChild(s);
      }
    });
  }

  /* ---------- reliable selected-state for swatches ---------- */

  function markSelectedBlocks(scope) {
    (scope || document).querySelectorAll('.variant-picker__option-values').forEach(function (wrap) {
      var labels = wrap.querySelectorAll('.block-swatch, .color-swatch');
      if (!labels.length) return;
      labels.forEach(function (l) { l.classList.remove('cfg-active'); });
      var checked = wrap.querySelector('input:checked');
      if (!checked) return;
      var lbl = labelFor(wrap, checked);
      if (lbl && (lbl.classList.contains('block-swatch') || lbl.classList.contains('color-swatch'))) {
        lbl.classList.add('cfg-active');
      }
    });
  }

  /* Re-apply the current material filter to the LIVE picker (we keep the picker
     across re-render now, so nothing else re-filters it) and refresh the toggle
     button + the hidden state. Safe to call on every variant change. */
  function resyncMaterial(scope) {
    scope = scope || document;
    var mat = window.__cfgMaterial;

    scope.querySelectorAll('.variant-picker__option').forEach(function (fs) {
      var wrap = fs.querySelector('.variant-picker__option-values');
      if (!wrap) return;

      var pairs = optionPairs(wrap);
      var present = {};
      pairs.forEach(function (p) {
        var nameEl = p.label || p.input;
        var m = materialOf(accessibleName(nameEl));
        p.__mat = m;
        if (m) present[m] = true;
      });

      // ONLY filter an option that actually contains BOTH materials (the
      // Schriftfarbe option). The wood-plate option is all "Holz ..." and must
      // never be filtered, or it would vanish when Acryl is active.
      var isSplit = present.Holz && present.Acryl;
      if (!isSplit) {
        // make sure nothing stays hidden on a non-split option
        pairs.forEach(function (p) {
          if (p.input) { p.input.classList.remove('cfg-hidden'); p.input.style.removeProperty('display'); }
          if (p.label) { p.label.classList.remove('cfg-hidden'); p.label.style.removeProperty('display'); }
        });
        return;
      }

      // refresh the toggle button active state
      fs.querySelectorAll('.cfg-material__btn').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-material') === mat);
      });

      if (!mat) return;

      // hide the wrong-material pair with INLINE display so no theme/app CSS can
      // override it; show the active-material pair
      pairs.forEach(function (p) {
        var hide = p.__mat && p.__mat !== mat;
        [p.input, p.label].forEach(function (el) {
          if (!el) return;
          if (hide) { el.classList.add('cfg-hidden'); el.style.setProperty('display', 'none', 'important'); }
          else { el.classList.remove('cfg-hidden'); el.style.removeProperty('display'); }
        });
      });
    });
  }

  /* ---------- run + observe ---------- */

  var target = document.querySelector('.product') || document.body;
  var scheduled = false;

  function enhanceAll() {
    document.querySelectorAll('variant-picker').forEach(enhancePicker);
    resyncMaterial(document);
    arrangeHeader(document);
    markSelectedBlocks(document);
    updateSelectedValues(document);
    renderDelivery(document);
    bindStickyQty();
  }

  var observer = new MutationObserver(function () {
    var hasNewPicker = document.querySelector('variant-picker:not([data-cfg])');
    if (scheduled) return;
    if (!hasNewPicker &&
        !document.querySelector('.cfg-delivery:not([data-cfg-done])')) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      observer.disconnect();
      try { enhanceAll(); } finally { observer.observe(target, { childList: true, subtree: true }); }
    });
  });

  function run() {
    observer.disconnect();
    try { enhanceAll(); } finally { observer.observe(target, { childList: true, subtree: true }); }

    if (CFG_DEBUG) {
      var vp = document.querySelector('variant-picker');
      var wrap = vp && vp.closest('.product-info__block-item');
      log('loaded DIAGNOSTIC build. Change ONE colour, then copy the [cfg] lines.');
      log('picker wrapper block =', wrap ? blockLabel(wrap) : '(no .product-info__block-item ancestor!)');

      /* swap logger: what does the theme add/remove during re-render? */
      var swapObs = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.type !== 'childList') return;
          function rel(n) {
            return n.nodeType === 1 && (
              (n.matches && (n.matches('.product-info__block-item') || n.matches('variant-picker'))) ||
              (n.querySelector && n.querySelector('variant-picker'))
            );
          }
          var rem = Array.prototype.filter.call(m.removedNodes, rel).map(blockLabel);
          var add = Array.prototype.filter.call(m.addedNodes, rel).map(blockLabel);
          if (rem.length) log('SWAP removed:', rem.join('  '), ' from', blockLabel(m.target));
          if (add.length) log('SWAP added:  ', add.join('  '), ' into', blockLabel(m.target));
        });
      });
      swapObs.observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* ---------- JUMP FIX + logging: keep our live picker across re-render ---------- */
  document.addEventListener('product:rerender', function (e) {
    var d = e.detail || {};
    var frag = d.htmlFragment;
    var kind = Object.prototype.toString.call(frag);
    var hasQSA = !!(frag && frag.querySelectorAll);
    var found = 0;
    if (hasQSA && !d.productChange) {
      // Strip blocks whose content never changes with the variant, so the theme
      // does NOT replace them. Replacing them collapses their height for a frame
      // and bounces the picker. The variant-picker we keep because our JS owns
      // it; the liquid block is static (social proof / delivery line).
      var blocks = frag.querySelectorAll('[data-block-type="variant-picker"], [data-block-type="liquid"]');
      found = blocks.length;
      blocks.forEach(function (b) { b.remove(); });
    }
    log('product:rerender FIRED  productChange=', !!d.productChange,
        ' fragmentType=', kind, ' hasQuerySelectorAll=', hasQSA,
        ' variant-picker-blocks-stripped=', found);
    if (hasQSA && !d.productChange && found === 0) {
      log('  WARNING: no [data-block-type="variant-picker"] found in fragment. ' +
          'The picker block may be nested differently or named differently -> not stripped -> still replaced.');
    }
  }, true);

  /* re-sync after a variant change (picker stays put) + probe heights */
  document.addEventListener('change', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('variant-picker'))) return;
    requestAnimationFrame(function () {
      resyncMaterial(document);
      markSelectedBlocks(document);
      updateSelectedValues(document);
      arrangeHeader(document);
    });
    if (CFG_DEBUG) probeHeights('change');
  }, true);

  document.addEventListener('mousedown', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('variant-picker'))) return;
    if (CFG_DEBUG) probeHeights('mousedown');
  }, true);

  /* height probe: logs which block moves/grows during the ~1.2s after interaction */
  var probing = false;
  function probeHeights(trigger) {
    if (probing) return;
    probing = true;
    var startedAt = performance.now();
    var col = document.querySelector('.product-info') || document.querySelector('.product');
    var vpWrap = (function () {
      var vp = document.querySelector('variant-picker');
      return vp && vp.closest('.product-info__block-item');
    })();

    function snap() {
      var blocks = {};
      document.querySelectorAll('.product-info__block-item').forEach(function (b) {
        var k = blockLabel(b);
        blocks[k] = Math.round(b.getBoundingClientRect().height);
      });
      return {
        col: col ? Math.round(col.getBoundingClientRect().height) : 0,
        vpTop: vpWrap ? Math.round(vpWrap.getBoundingClientRect().top) : 0,
        vpH: vpWrap ? Math.round(vpWrap.getBoundingClientRect().height) : 0,
        blocks: blocks
      };
    }

    var base = snap();
    log('PROBE start (' + trigger + '): picker-top=' + base.vpTop + ' picker-h=' + base.vpH + ' column-h=' + base.col);

    function frame() {
      var now = snap();
      var t = Math.round(performance.now() - startedAt);
      if (Math.abs(now.vpTop - base.vpTop) > 1) {
        log('  t+' + t + 'ms  PICKER MOVED ' + (now.vpTop - base.vpTop) + 'px (top ' + base.vpTop + '->' + now.vpTop + ')');
        base.vpTop = now.vpTop;
      }
      if (Math.abs(now.vpH - base.vpH) > 2) {
        log('  t+' + t + 'ms  picker HEIGHT ' + base.vpH + '->' + now.vpH);
        base.vpH = now.vpH;
      }
      Object.keys(now.blocks).forEach(function (k) {
        var was = base.blocks[k];
        if (was == null) { log('  t+' + t + 'ms  BLOCK APPEARED ' + k + ' h=' + now.blocks[k]); base.blocks[k] = now.blocks[k]; return; }
        if (Math.abs(now.blocks[k] - was) > 2) {
          log('  t+' + t + 'ms  BLOCK ' + k + ' height ' + was + '->' + now.blocks[k]);
          base.blocks[k] = now.blocks[k];
        }
      });
      Object.keys(base.blocks).forEach(function (k) {
        if (now.blocks[k] == null) { log('  t+' + t + 'ms  BLOCK REMOVED ' + k); delete base.blocks[k]; }
      });
      if (performance.now() - startedAt < 1200) {
        requestAnimationFrame(frame);
      } else {
        probing = false;
        log('PROBE end (' + trigger + ')');
      }
    }
    requestAnimationFrame(frame);
  }
})();